import { render, staticRenderFns } from "./modal_person_form.vue?vue&type=template&id=7c538b6b&scoped=true"
import script from "./modal_person_form.vue?vue&type=script&lang=js"
export * from "./modal_person_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c538b6b",
  null
  
)

export default component.exports